import axios from 'axios';
import TokenService from '../services/token.service';
import { Routes } from '../constants/routes';
const host = process.env.REACT_APP_BACKEND_URL;
const client = axios.create({
    baseURL: `${host}/`,
    headers: {
        'Content-type': 'application/json'
    }
});
export const updateHeaderAuthorizationToken = (token) => (client.defaults.headers.common['Authorization'] = `Bearer ${token}`);
client.defaults.headers.common['x-requested-with'] = window.location.origin;
updateHeaderAuthorizationToken(TokenService.getWalletAccessToken() || '');
client.interceptors.response.use((config) => config, (error) => {
    const originalConfig = error.config;
    if (originalConfig.url === '/auth/login' || !error.response) {
        // Flow-through
    }
    else if (error.response.status === 401 && !originalConfig._retry) {
        // Access Token is expired
        const refreshToken = TokenService.getWalletRefreshToken();
        originalConfig._retry = true;
        return client
            .post(`${host}/auth/refresh`, { token: refreshToken }, originalConfig)
            .then(async (rs) => {
            const { accessToken, refreshToken } = rs.data;
            TokenService.setWalletTokens(accessToken, refreshToken);
            return accessToken;
        })
            .then((token) => {
            updateHeaderAuthorizationToken(token);
            originalConfig.headers.Authorization = `Bearer ${token}`;
            return client(originalConfig);
        })
            .catch((error) => {
            if (error.code !== 'ERR_BAD_REQUEST') {
                TokenService.flush();
                window.location.href = Routes.LOGIN;
            }
        });
    }
    return Promise.reject(error);
});
export default client;
